import {React, useEffect, useState} from "react";
import { FaPlus, FaMinus } from 'react-icons/fa';
import { FaShoppingCart } from 'react-icons/fa';
import { href } from "react-router-dom";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function horizontalSpacer(width) {
  return <div style={{ display: "inline-block", width: width }}></div>;
}

function verticalSpacer(height) {
  return <div style={{ height: height }}></div>;
}



function CartPage(){
    const [userCart, setUserCart] = useState([])
    const windowSize = useWindowSize();
    const [cartTotal, setCartTotal] = useState(0)
    const [finalTotal, setFinalTotal] = useState(0)
    const apiKey = process.env.REACT_APP_API_KEY;

    useEffect(() => {
            window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const userCartFromStorage = localStorage.getItem("userCart");
        if(userCartFromStorage){
            const parsedCartData = JSON.parse(userCartFromStorage);
            setUserCart(parsedCartData)
            checkTotal(parsedCartData)
        }
    }, []);


    const handleUserCheckout = async () =>{
        const simplifiedCart = userCart.map(item => ({
            pid: item.productInfo.pid,
            count: item.count
        }));

        console.log(simplifiedCart)

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/checkout`, {
            method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({api_key: apiKey, cart: simplifiedCart }),
        });

        const data = await response.json();
        //console.log(data)
        window.location.replace(`${data.url}`);
    }

    // useEffect(() => {
    //     const userCartFromStorage = localStorage.getItem("userCart");
    //     const parsedCartData = JSON.parse(userCartFromStorage);
    //     if(parsedCartData !== userCart){
    //         console.log("Charging User Cart Storage")
    //         localStorage.setItem('userCart', JSON.stringify(userCart));
    //     }
    // }, [userCart]);

    function checkTotal(userCartInfo){
        let total = 0
        for (let i = 0; i < userCartInfo.length; i++){
            total += (+userCartInfo[i].productInfo.price * userCartInfo[i].count)
        }
        setCartTotal(total)
        setFinalTotal(total)
        // checkFinalTotal(total)
    }

    // function checkFinalTotal(subtotal){
    //     let total = subtotal + (subtotal * (6/100))
    //     setFinalTotal(total)
    // }

    return(
        <div>
        <div className="CartPageContainer">
            {userCart.length > 0 ?
            <div>
            <p style={{fontSize: "24px",
                fontWeight: "bold",
                color: "#333333",
                textAlign: "center",
                marginBottom: "3px",
                
                }}>
                   Cart
                </p>

            {verticalSpacer(20)}
            
            <div>
                
                <div style={{
                    marginRight: "7%",
                    display: "flex",
                    padding: "10px"
                }}>{horizontalSpacer(60)}Product {horizontalSpacer(580)}Price</div>
            </div>
            {userCart.map(product => (
            <div key={product.productInfo.pid}
                className="AminProductsContainer"
                style={{
                background: "rgba(166, 158, 158, 0.9)",
                borderRadius: 20,
                width: "90%",
                height: 20,
                paddingTop: 10,
                paddingLeft: 20,
                paddingBottom: 100,
                alignItems: "left",
                marginBottom: '4%',
                display: 'flex', flexDirection: 'row',
                
            }}>
                
                {product.productInfo.pname} <br/>
                {product.productInfo.size}
                {/* {product.productInfo.price}<br/> */}
                
                
                <img
                    style={{
                        width: "auto",
                        height: 50,
                        objectFit: 'cover',
                        display: "block",
                        margin: "0 auto",
                        marginLeft: "5%",
                        borderRadius: "10px",
                    }}
                    src={product.productPictures[0]} // Already a complete URL
                    alt={product.pname}
                    onError={(e) => {
                        console.error("Image failed to load:", product.productPictures[0]);
                        e.target.style.display = 'none';
                    }}
                />
                {horizontalSpacer(20)}

                <div style={{
                        // width: '30%',
                        height: "100%",
                        paddingBottom: "3%",
                        display: "flex", flexDirection: "column",
                        // alignItems: "center",
                        
                    }}>
                        <div style={{
                        width: '100%',
                        height: "100%",
                        borderRadius: "10px",
                        paddingBottom: "3%",
                        display: "flex", flexDirection: "row",
                        justifyContent: "center"
                    }}>
                <button
                    style={{
                        width: '40%',
                        height: "auto",
                        aspectRatio: '1 / 1', 
                        marginRight: "2%",
                        border: "1px solid #fb2e2e",
                        background: "#c33737",
                        borderRadius: "20%",    
                        fontSize: "15px",
                        cursor: "pointer",
                        display: "flex",       
                        alignItems: "center",   
                        justifyContent: "center", 
                        color: "#000000ff",
                        padding: "6px"
                    }}
                type="button" onClick={() => {
                    if(product.count > 1){
                        let newCart = []
                        for (let i = 0; i < userCart.length; i++){
                            if(userCart[i].productInfo.pid === product.productInfo.pid){
                                const userCartToStorage = {
                                    productInfo: product.productInfo,
                                    productPictures: product.productPictures,
                                    count: product.count-1
                                }
                                newCart.push(userCartToStorage)
                            }
                            else{
                                newCart.push(userCart[i])
                            }
                        }

                        localStorage.setItem('userCart', JSON.stringify(newCart));
                        setUserCart(newCart)
                        checkTotal(newCart)
                    }
                    else{
                        let newCart = []
                        for (let i = 0; i < userCart.length; i++){
                            if(userCart[i].productInfo.pid !== product.productInfo.pid){
                                newCart.push(userCart[i])
                            }
                        }

                        localStorage.setItem('userCart', JSON.stringify(newCart));
                        setUserCart(newCart)
                        checkTotal(newCart)
                        

                    }
                }}>
                    <FaMinus />
                </button>

                <button
                    style={{
                        width: '40%',
                        height: "auto",
                        aspectRatio: '1 / 1', 
                        marginLeft: "3%",
                        border: "1px solid #14c10e",
                        background: "#1e6727",
                        borderRadius: "20%",    
                        fontSize: "15px",
                        cursor: "pointer",
                        display: "flex",       
                        alignItems: "center",   
                        justifyContent: "center", 
                        color: "#000000ff",
                        padding: "6px"
                    }}
                type="button" onClick={() => {
                    if(product.count < product.productInfo.available){
                        let newCart = []
                        for (let i = 0; i < userCart.length; i++){
                            if(userCart[i].productInfo.pid === product.productInfo.pid){
                                const userCartToStorage = {
                                    productInfo: product.productInfo,
                                    productPictures: product.productPictures,
                                    count: product.count+1
                                }
                                newCart.push(userCartToStorage)
                            }
                            else{
                                newCart.push(userCart[i])
                            }
                        }

                        localStorage.setItem('userCart', JSON.stringify(newCart));
                        setUserCart(newCart)
                        checkTotal(newCart)
                    }
                    else{
                        alert(`You've reached the maximum allowed for ${product.productInfo.pname}`)
                    }
                }}>
                    <FaPlus />
                </button>
                {horizontalSpacer(20)}
                ${product.productInfo.price}
                {horizontalSpacer(5)}
                </div>
                {/* {horizontalSpacer(50)} */}
                <p> Total: {product.count}</p>
                
                </div>

                
            </div>
            ))
            
        }
            <div style={{
                background: "#000000",
                height: "2px",
                width: "95%"
                        
            }}>
            </div>
            <div>
                <div style={{
                    marginRight: "7%",
                    display: "flex",
                    padding: "10px",
                    paddingBottom: "15px"
                }}>Subtotal {horizontalSpacer(650)} ${Number(cartTotal).toFixed(2)}</div>
            </div>

            <div>
                <div style={{
                    marginRight: "7%",
                    display: "flex",
                    padding: "10px",
                    paddingBottom: "15px"
                }}>Shipping {horizontalSpacer(650)} Free</div>
            </div>

            {/* <div>
                <div style={{
                    marginRight: "7%",
                    display: "flex",
                    padding: "10px",
                    paddingBottom: "15px"
                }}>Tax {horizontalSpacer(750)} 6%</div>
            </div> */}
            <div>
                <div style={{
                    marginRight: "7%",
                    display: "flex",
                    padding: "10px",
                    paddingBottom: "15px"
                }}>Total {horizontalSpacer(750)} ${Number(finalTotal).toFixed(2)}</div>
            </div>

            {verticalSpacer(30)}
                <button
                style={{
                    padding: "8px 16px",
                    width: "95%",
                    height: "35px",
                    borderRadius: 6,
                    border: "1px solid #333",
                    background: "rgb(9, 129, 13)",
                    cursor: "pointer",
                    marginRight: 8,
                    color: "#000000ff",
                    fontWeight: "bolder",
                    fontSize: "15px"
                }}
                onMouseEnter={(e) =>
                    (e.currentTarget.style.background =  "#f0f0f0")
                }
                onMouseLeave={(e) => (e.currentTarget.style.background = "rgb(9, 129, 13)")}
                onClick={() => {
                    // window.location.replace('/CheckoutSuccessfulPage')
                    handleUserCheckout()
                }}
                >
              Check Out
            </button>

              </div>
              : 
            //   If the user car if empty
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "60px 20px",
                textAlign: "center",
                minHeight: "400px"
                }}>
                <FaShoppingCart 
                    style={{
                    fontSize: "80px",
                    color: "#ccc",
                    marginBottom: "24px"
                    }}
                />
                <p style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "12px",
                    letterSpacing: "1px"
                }}>
                    YOUR CART IS EMPTY
                </p>
                <p style={{
                    fontSize: "16px",
                    color: "#666",
                    marginBottom: "32px"
                }}>
                    Add some items to get started
                </p>
                <button
                    style={{
                    padding: "16px 48px",
                    height: "56px",
                    borderRadius: "8px",
                    border: "none",
                    background: "rgb(9, 129, 13)",
                    cursor: "pointer",
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "16px",
                    letterSpacing: "0.5px",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 12px rgba(9, 129, 13, 0.3)"
                    }}
                    onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgb(7, 105, 10)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 16px rgba(9, 129, 13, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgb(9, 129, 13)";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(9, 129, 13, 0.3)";
                    }}
                    onClick={() => {
                    window.location.replace('/');
                    }}
                >
                    SHOP NOW
                </button>
                </div>
            }

        </div>
        {verticalSpacer((windowSize.width * 0.5) + (windowSize.height * 0.8))}
        </div>
    );
}
export default CartPage;